import Script from "next/script";
import React  from "react";

import paytmScript from "./PaytmCheckout";

const donationFlowPaytm = ( { moneyDonationId, token, amount, onSuccess, onFailure, onScriptFailure, onScriptSuccess } ) => {

	paytmScript ( { moneyDonationId, token, amount, onSuccess, onFailure, onScriptSuccess, onScriptFailure } );

	return null;

};

export default donationFlowPaytm;
